/**
 * Point d'intégration UNIQUE de l'état « non lu » des Tickets, branché sur le système de
 * notifications utilisateur : la pastille d'une carte s'allume quand une notification NON LUE du
 * sujet « tickets » pointe vers ce ticket (linkPath « /tickets?ticket={id} »), et s'éteint dès que
 * la notification est marquée lue. Les composants consommateurs (TicketListCard) n'ont pas changé :
 * ils appellent ce hook et affichent le point quand il répond `true`.
 */
import { useTicketNotificationUnread } from "../../Realtime/useNotifications";

export const useTicketUnread = (ticketId: string): boolean => useTicketNotificationUnread(ticketId);

export default useTicketUnread;
